const NavigationMenuDefaultProps = {
  pages: [],
  rootRoute: ''
}

export default NavigationMenuDefaultProps
